import React from 'react';
import { connect } from 'react-redux';

import { RootState } from 'MyTypes';

import { OrganizationMember } from '@portal/common/types';

import { getSessionAccount } from '../../store/root-reducer';
import View from './View';

type Props = {
    account: OrganizationMember;
};

const mapStateToProps = (state: RootState) => ({
    account: getSessionAccount(state),
});

class Navigation extends React.PureComponent<Props> {
    render() {
        return <View {...this.props} />;
    }
}

export default connect(mapStateToProps)(Navigation);
